import { Box, Grid } from "@mui/material";
import { Field } from "formik";
import React from "react";
import { Inputs } from "../formInputs";
import { Base } from "../base";
import theme from "../../theme";
import JobType from "../../types/jobType";
import { RemoveCircle } from "@mui/icons-material";
import KeyValue from "../../types/keyValue";

interface Props {
  values: JobType;
  handleAdd: () => void;
  handleClose: () => void;
  handleRemove: (k: KeyValue) => void;
  index?: number;
}

const ManageJobTypeKeyValueOptionForm: React.FC<Props> = (props) => {
  const { values, handleAdd, handleClose, handleRemove, index } = props;
  return (
    <Grid
      container
      flex={1}
      sx={{
        width: { lg: 1024, md: 900, xs: window.innerWidth },
        backgroundColor: theme.palette.background.paper,
        paddingX: 5,
        paddingY: 3,
      }}
      spacing={2}
    >
      <Grid size={{ xs: 6 }}>
        <Grid container justifyContent={"stretch"} alignItems={"center"}>
          <Grid size={{ xs: 12 }}>
            <Field component={Inputs.Text} name="add" />
            <Grid justifySelf={"flex-end"}>
              <Base.Button
                text={"Add Choice"}
                onClick={handleAdd}
                disabled={!values.add}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Grid container direction={"column"}>
          <Box sx={{ height: "140px", overflowY: "scroll" }}>
            {values.questions[index!].choices.map((s) => (
              <Grid key={s.value} mb={2}>
                <Grid container direction={"row"} alignItems={"center"} gap={1}>
                  <RemoveCircle
                    onClick={() => handleRemove(s)}
                    sx={{ cursor: "pointer" }}
                  />
                  {s.value}
                </Grid>
              </Grid>
            ))}
          </Box>
        </Grid>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Grid container justifyContent={"flex-end"}>
          <Base.Button text="Close" onClick={handleClose} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ManageJobTypeKeyValueOptionForm;
